import gql from 'graphql-tag';

export default gql`
  mutation UpdateAsset($assetId: String!, $input: AssetInput!) {
      updateAsset(assetId: $assetId, input: $input) {
        assetId
        organisationId
        filename
        title
        description
        tags
        createdAt
        updatedAt
        altText
        metaData
        permissions
        assetFiles {
          ORIGINAL {
            assetFileId
            type
            status
            sourceUrl
          },
          THUMBNAIL {
            assetFileId
            type
            status
            sourceUrl
          },
          HD {
            assetFileId
            type
            status
            sourceUrl
          },
          SD {
            assetFileId
            type
            status
            sourceUrl
          },
          CAPTION {
            assetFileId
            type
            status
            sourceUrl
            metaData
          },
          VTT_CAPTION {
            assetFileId
            type
            status
            sourceUrl
            metaData
          }
      }
    }
  }
`;